module.exports = __webpack_public_path__ + "img/nophoto.065921a4.png";